/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-12 15:38:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-23 21:04:37
 * @FilePath: /knit-web/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* eslint-disable no-underscore-dangle */
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from 'vue-router';
import NProgress from 'nprogress'; // progress bar
import { trackPageView } from '@/utils/analytics';
import 'nprogress/nprogress.css';
import { appRoutes } from './routes';
import createRouteGuard from './guard';
import { DEFAULT_LAYOUT } from './constants';
import type { AppRouteRecordRaw } from './routes/types';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

/**
 * 将嵌套路由展平为一维数组
 * 每个路由都有完整的路径（相对于父路由）
 * 例如：/develop 下的 workflow 会变成 develop/workflow
 */
function flattenRoutes(
  routes: AppRouteRecordRaw[],
  parentPath = ''
): RouteRecordRaw[] {
  const result: RouteRecordRaw[] = [];

  routes.forEach((route) => {
    // 构建完整路径
    const routePath = route.path.startsWith('/')
      ? route.path.slice(1)
      : route.path;
    const fullPath = parentPath ? `${parentPath}/${routePath}` : routePath;

    if (route.children && route.children.length > 0) {
      // 如果有子路由，递归展平
      const flattenedChildren = flattenRoutes(route.children, fullPath);
      result.push(...flattenedChildren);

      // 如果有 redirect，添加一个重定向路由
      if (route.redirect) {
        // redirect 需要是完整路径（相对于 /space/:workspace_uuid）
        const redirectPath = route.redirect.startsWith('/')
          ? route.redirect.slice(1)
          : route.redirect;
        result.push({
          path: fullPath,
          redirect: redirectPath, // 相对于父路由的路径
          name: route.name,
          meta: route.meta,
        } as RouteRecordRaw);
      }
    } else {
      // 叶子路由，直接添加（不包含 children 属性）
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { children: _children, ...routeWithoutChildren } = route as any;
      result.push({
        ...routeWithoutChildren,
        path: fullPath,
      } as RouteRecordRaw);
    }
  });

  return result;
}

// 展平后的路由
const workspaceRoutes = flattenRoutes(appRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index.vue'),
    },
    // 添加 workspace 路由包装器，所有需要项目信息的路由都放在这里
    {
      path: '/space/:workspace_uuid',
      component: DEFAULT_LAYOUT,
      meta: {
        requiresAuth: true,
      },
      children: [
        // 默认路由，重定向到 welcome
        {
          path: '',
          redirect: 'discover/homepage',
        },
        ...workspaceRoutes,
      ],
    },
    // {
    //   path: '/document',
    //   name: 'Document',
    //   component: () => import('@/views/document/index.vue'),
    //   meta: {
    //     locale: 'menu.document',
    //     requiresAuth: false,
    //     icon: 'icon-book',
    //     order: 99,
    //     hideInMenu: true,
    //     // subMenu: {
    //     //   component: () =>
    //     //     import(
    //     //       '@/layout/sider/components/sub-menu-components/document-submenu.vue'
    //     //     ),
    //     //   props: {
    //     //     breakpoint: 'md',
    //     //     floating: true,
    //     //   },
    //     //   storeName: 'documentSubMenu',
    //     // },
    //   },
    // },
    {
      path: '/bind-invite',
      name: 'BindInvite',
      component: () => import('@/views/BindInvite/index.vue'),
      meta: {
        locale: 'menu.document',
        requiresAuth: false,
        icon: 'icon-book',
        order: 99,
        hideInMenu: true,
      },
    },
    {
      path: '/contact-us',
      name: 'Contact',
      component: () => import('@/views/contact-us/index.vue'),
      meta: {
        locale: 'menu.contact',
        requiresAuth: false,
        icon: 'icon-phone',
        order: 100,
        hideInMenu: true,
      },
      children: [],
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('@/views/policy/privacy-policy.vue'),
      meta: {
        requiresAuth: false,
        hideInMenu: true,
      },
    },
    {
      path: '/terms-of-use',
      name: 'TermsOfUse',
      component: () => import('@/views/policy/terms-of-use.vue'),
      meta: {
        requiresAuth: false,
        hideInMenu: true,
      },
    },
    {
      path: '/403',
      name: 'Forbidden',
      component: () => import('@/views/errors/403.vue'),
    },
    // 原有路由重定向到 /space/:workspace_uuid 下（在路由守卫中处理）
    // 不再直接添加原有路由，避免名称冲突
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/views/not-found/index.vue'),
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

createRouteGuard(router);

// chunk加载失败时自动刷新页面（无损发版兜底）
router.onError((error) => {
  if (
    /Loading chunk|Failed to fetch dynamically imported module|load module script/i.test(
      error.message
    )
  ) {
    window.location.reload();
  }
});

router.afterEach((to, _from, failure) => {
  if (failure) {
    return;
  }

  trackPageView(to);
});

// eslint-disable-next-line no-console
console.log(
  '[Router] Resolved routes:',
  router.getRoutes().map((r) => ({
    path: r.path,
    name: r.name,
  }))
);

export default router;
